import './App.css';
import { Col, Grid, Row, Typography, Button} from 'antd';
import { useEffect } from "react";
import ContactsBanner from './img/ContactsBanner.jpg';
import HomePageImgFamilyOneWeb from './img/HomePageImgFamilyOneWeb.png';
import HomePageImgEnterpriseOneWeb from './img/HomePageImgEnterpriseOneWeb.png';
import AmberFinLogo from './img/AmberFinLogo.png';
import { NavLink } from "react-router-dom";

const { Title, Text } = Typography;

function Services() {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;
  return (
        <>
            <Row 
            className={'page-row'}
            style={{
                maxWidth: 1024,
                margin: '24px auto 0 auto',
                textAlign: "center"
            }}>
                <Col span={24}>
                    <Title level={1}>We turn complexity into working systems</Title>
                    <Title level={4} style={{fontWeight: "normal"}}>
                        We help you adopt AI, build robust systems, and deliver solutions that actually work. <br />Welcome to IT that delivers.</Title>
                    <br />
                    <NavLink className={"menu"} to={'/contacts'}>
                        <Button 
                            size="large"
                            variant='solid'
                            color="default" 
                            style={{marginBottom: 48}}>
                                Contact sales
                        </Button>
                </NavLink>
           
                </Col>
            </Row>
            
            <Row 
            className={'page-row'}
            style={{
                maxWidth: 1024,
                margin: '24px auto 0 auto'
            }}
            gutter={[0, 16]}>
                <Col
                    xs={24} md={8}
                    style={{padding: "0 8px"}}
                >
                    <div style={{
                        borderRadius: 24,
                        backgroundColor: 'black',
                        height: "440px",
                        position: "relative",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>AI Adoption </h1>
                            <Text type='secondary' style={{display: 'block'}}>data / integration / security</Text>
                        </div>
                        <p style={{color: 'white', padding: 32}}>AI adoption is often approached as a technology initiative, rather than a business capability — and that’s where most organisations go wrong.</p>
                        <Title level={1} style={{color: 'white', fontWeight: 300, fontSize: 56, marginTop: 0, padding: '0 32px', textAlign: 'right'}}>
                            <small style={{fontSize: 14}}>from</small> 120€/h</Title>
                            <NavLink className={"menu"} to={'/contacts'}>
                        <Button
                            size="samll"
                            variant='solid'
                            color="default"
                            style={{margin: '28px auto 0 auto', display: 'block'}}>
                                Contact sales
                        </Button>
                        </NavLink>
                    
                        
                        <img src={AmberFinLogo} style={{ maxWidth: '18px', position: 'absolute', bottom: 32, left: 32 }} alt={'Amber IT Logo'} />
                    </div>
                </Col>
                <Col xs={24} md={8} style={{padding: "0 8px"}}>
                    <div style={{
                        borderRadius: 24,
                        backgroundColor: 'black',
                        height: "440px",
                        position: "relative",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>IT Engineering</h1>
                            <Text type='secondary' style={{display: 'block'}}>development / infrastructure</Text>
                        </div>
                        <p style={{color: 'white', padding: 32}}>
                            Many organisations focus on speed of delivery or visible features, but overlook the fundamentals: architecture, security, operations and ownership.</p>
                        <Title level={1} style={{color: 'white', fontWeight: 300, fontSize: 56, marginTop: 0, padding: '0 32px', textAlign: 'right'}}>
                            <small style={{fontSize: 14}}>from</small> 80€/h</Title>
                            <NavLink className={"menu"} to={'/contacts'}>
                        <Button
                            size="samll"
                            variant='solid'
                            color="default"
                            style={{margin: '28px auto 0 auto', display: 'block'}}>
                                Contact sales
                        </Button>
                        </NavLink>
                        
                        <img src={AmberFinLogo} style={{ maxWidth: '18px', position: 'absolute', bottom: 32, left: 32 }} alt={'Amber IT Logo'} />
                    
                    </div>
                </Col>
                <Col 
                    xs={24} md={8} 
                    style={{padding: "0 8px"}}
                >
                <div style={{
                        borderRadius: 24,
                        backgroundColor: 'black',
                        height: "440px",
                        position: "relative",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>Fintech</h1>
                            <Text type='secondary' style={{display: 'block'}}>payments / lending / AML / KYC</Text>
                        </div>
                        <p style={{color: 'white', padding: 32}}>
                            Many organisations focus on speed of delivery or visible features, but overlook the fundamentals: architecture, security, operations and ownership.</p>
                        <Title level={1} style={{color: 'white', fontWeight: 300, fontSize: 56, marginTop: 0, padding: '0 32px', textAlign: 'right'}}>
                            <small style={{fontSize: 14}}>custom</small> €</Title>
                            <NavLink className={"menu"} to={'/contacts'}>
                        <Button
                            size="samll"
                            variant='solid'
                            color="default"
                            style={{margin: '28px auto 0 auto', display: 'block'}}>
                                Contact sales
                        </Button>
                        </NavLink>
                        
                        <img src={AmberFinLogo} style={{ maxWidth: '18px', position: 'absolute', bottom: 32, left: 32 }} alt={'Amber IT Logo'} />
                    </div>
                    </Col>
            </Row>
            <Row className={'page-row'} style={{
                maxWidth: 1024,
                margin: '24px auto 96px auto',
                textAlign: "center"
            }}>
                                   

                <Col span={24}>
                    <Title level={1} style={{marginTop: isMobile ? 48 : 128}}>Reliable IT services built for real-world demands</Title>
                    <Title level={4} style={{fontWeight: "normal"}}>Delivering engineering services that meet business, security and regulatory requirements — designed <br/>for performance, resilience and seamless integration.</Title>
                </Col>
            </Row>

            <Row className={'page-row'} style={{
                maxWidth: 1024,
                margin: isMobile ? '48px auto 0 auto' : '126px auto 0 auto',
                textAlign: "center"
            }}>
                                   

                <Col span={24}>

                    <p>“Strategy without execution is hallucination.” — Thomas Edison</p>
                    <br />
                    <p style={{ textAlign: "right", fontSize: 10 }} className={"amber-title-color"}>
                        <strong>AMBER</strong>TECHNOLOGIES
                    </p>
                </Col>
            </Row>
        </>
    );
}

export default Services;